import axios from '@/plugins/axios'

export function getRidingCard(params = {}) {
  return axios.get('card_riding', { params })
}

export function storeRidingCard(data) {
  return axios.post('card_riding', data)
}

export function destroyRidingCard(id) {
  return axios.delete(`card_riding/${id}`)
}

export function updateRidingCard(id, data) {
  return axios.put(`card_riding/${id}`, data)
}

export function editRidingCard(id) {
  return axios.get(`card_riding/${id}/edit`)
}

export function giveCardToUser(data) {
  return axios.post('card_riding/giveCardToUser', data)
}
